import React from 'react';
import { ScalesIcon } from '@phosphor-icons/react';
import { Tab } from '../../../../components';
import LossesProperties from './LossesProperties';
import { TabItem } from '../../../../@types/types';

const Losses: React.FC = () => {
    const items: TabItem[] = [
        {
            icon: (<ScalesIcon size={24} weight='fill' />),
            content: (<LossesProperties/>),
            title: 'Losses',
            is_active: true,
        }
    ];

    return (<Tab items={items}/>);
}

export default Losses;
